import React from 'react';
import clsx from 'clsx';
import styles from './PrintAddOnsDay.module.scss';
import { PrintBookingDetailAddOnViewModel } from '../utils/PrintBookingDetailViewModel';

type Props = {
    addOns: PrintBookingDetailAddOnViewModel[];
    className?: string;
};

export const PrintAddOnsDay: React.FC<Props> = ({ addOns, className }) => {
    if (!addOns?.length) return null;

    return (
        <div className={clsx(styles.root, className)}>
            <div className={styles.title}>Add-ons</div>

            <div className={styles.list}>
                {addOns.map(a => (
                    <div
                        key={a.id}
                        className={styles.row}
                    >
                        <div className={styles.time}>{a.timeLabel}</div>
                        <div className={styles.name}>{a.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrintAddOnsDay;
